import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40a50d33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "footer-form" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "footer-line"
}
const _hoisted_7 = { class: "copyright" }
const _hoisted_8 = ["href"]


import type { Footer } from "@/types";

interface FooterProps {
  data: Footer;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
    data: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.sections, (section, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-sm-4",
            key: index
          }, [
            _createElementVNode("h5", null, _toDisplayString(section.title), 1),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.list, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      href: item.href
                    }, _toDisplayString(item.text), 9, _hoisted_5)
                  ]),
                  (index < section.list.length - 1)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", null, _toDisplayString(__props.data.copyright), 1),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: __props.data.record.href,
            target: "_blank"
          }, _toDisplayString(__props.data.record.text), 9, _hoisted_8)
        ])
      ])
    ])
  ]))
}
}

})